import React, {useRef, useState, useEffect } from 'react';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import {edit, listType} from '../../../lib/api/judge';

export function Edit({ initialData, onClose, onSave }) {
  const [judge, setJudge] = useState(initialData);
  const [judgesType, setJudgesType] = useState([]);
  const [errors, setErrors] = useState({
    name: false,
    last_name: false,
    jmbg: false
  });

  const [previewImage, setPreviewImage] = useState(null);

  console.log('judge.document_guid',judge.entities_guide)
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (judge?.entities_guide) {
      setPreviewImage(process.env.REACT_APP_BASE_API_URL +`/uploads/${judge.image_path}`);
    }
    async function fetchData() {
      const rowType = await listType();
      setJudgesType(rowType);
    }
    fetchData();
  }, [judge.entities_guide]);

  const handelInput = e => {
    const { name, value } = e.target;
    setJudge({ ...judge, [name]: value });
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!validateForm(event)) return;

    const form = event.currentTarget;
    const _data = {
      name: form.name.value,
      last_name: form.last_name.value,
      jmbg: form.jmbg.value,
      judges_type_id: !form.judges_type_id.value,
      code: !form.code.value,
      descreption: form.descreption.value
    };

    const formData = new FormData(event.currentTarget);
    //formData.append('descreption', '');

    await edit(Object.fromEntries(formData.entries()), judge.document_guid);

    //await edit(_data, judge.document_guid);
    onSave();
    onClose();
  };

  const handleImageChange = e => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPreviewImage(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const validateForm = event => {
    const form = event.currentTarget;
    const newErrors = {
      name: !form.name.value.trim(),
      last_name: !form.last_name.value.trim(),
      jmbg: !form.jmbg.value
    };
    setErrors(newErrors);

    if (Object.values(newErrors).some(error => error)) {
      event.stopPropagation();
      return false;
    }
    return true;
  };

  return (
      <Card>
        <Card.Body className="bg-body-tertiary">
          <Form
              method="PUT"
              encType="multipart/form-data"
              noValidate
              onSubmit={handleSubmit}
          >
            <Row className="mb-3">
              <Col md="6">
                <Form.Label>Slika</Form.Label>
                <div
                    onClick={() => fileInputRef.current?.click()}
                    style={{
                      cursor: 'pointer',
                      width: 120,
                      height: 120,
                      borderRadius: '50%',
                      overflow: 'hidden',
                      border: '2px dashed #ccc',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                >
                  {previewImage ? (
                      <img
                          src={previewImage}
                          alt="Preview"
                          onError={(e) => {
                            e.target.onerror = null; // spreči loop ako fallback ne postoji
                            if (!e.target.dataset.fallbackTried) {
                              e.target.src = process.env.REACT_APP_BASE_API_URL +'/uploads/blank.jpg';
                              e.target.dataset.fallbackTried = 'true';
                            }
                          }}
                          style={{width: '100%', height: '100%', objectFit: 'cover'}}
                      />
                  ) : (
                      <span className="text-muted">Klikni za sliku</span>
                  )}
                </div>
                <Form.Control
                    type="file"
                    name="image"
                    accept="image/*"
                    style={{display: 'none'}}
                    ref={fileInputRef}
                    onChange={handleImageChange}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="name">
                <Form.Label>Ime</Form.Label>
                <Form.Control
                    required
                    type="text"
                    name="name"
                    value={judge.name || ''}
                    onChange={handelInput}
                    isInvalid={errors.name}
                />
                <Form.Control.Feedback type="invalid">Molimo unesite ime.</Form.Control.Feedback>
              </Form.Group>

              <Form.Group as={Col} md="6" controlId="last_name">
                <Form.Label>Perzime</Form.Label>
                <Form.Control
                    required
                    type="text"
                    name="last_name"
                    value={judge.last_name || ''}
                    onChange={handelInput}
                    isInvalid={errors.last_name}
                />
                <Form.Control.Feedback type="invalid">Molimo unesite prezime.</Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="6">
                <Form.Label>Vrsta</Form.Label>
                <Form.Select name="judges_type_id" isInvalid={errors.judges_type_id}  onChange={handelInput} value={judge.judges_type_id || ''}>
                  {judgesType.map(f => <option key={f.judges_type_id} value={f.judges_type_id}>{f.name}</option>)}
                </Form.Select>
              </Form.Group>

              <Form.Group as={Col} md="6" controlId="code" >
                <Form.Label>Oznaka</Form.Label>
                <Form.Control required type="text" name="code" value={judge.code || ''}  onChange={handelInput} isInvalid={errors.code} />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="place">
                <Form.Label>Mjesto</Form.Label>
                <Form.Control required type="text" name="place"/>
              </Form.Group>

              <Form.Group as={Col} md="6" controlId="jmbg">
                <Form.Label>JMBG</Form.Label>
                <Form.Control required type="text" name="jmbg" value={judge.jmbg || ''}  onChange={handelInput} isInvalid={errors.jmbg} />
                <Form.Control.Feedback type="invalid">Molimo unesite jmbg.</Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group className="mb-3" controlId="descreption">
                <Form.Label>Opis</Form.Label>
                <Form.Control as="textarea" name="descreption" rows={3}  value={judge.descreption || ''}  onChange={handelInput}/>
              </Form.Group>
            </Row>
            <Button type="submit">Sačuvaj</Button>
          </Form>
        </Card.Body>
      </Card>
  );
}
